export default function /* @ngInject */ authData($q, $rootScope, events, userService) {
    let deferUser, userPromise;

    // Get user from window initially.
    deferUser = $q.defer();
    deferUser.resolve(window.user);
    userPromise = deferUser.promise;
    delete window.user;

    // Get fresh data whenever something changes.
    $rootScope.$on(
        events.authChange,
        (event, authenticated) => {
            if (authenticated) {
                userPromise = userService.get();
            }
            else {
                userPromise = new Promise((resolve) => resolve(null));
            }
        }
    );

    return function() {
        let deferredAuthData = $q.defer();

        // Convert userPromise to authDataPromise, because authDataPromise needs
        // to resolve the promise with `null` when there is no user, whereas
        // authDataPromise will reject a promise when there's no user.
        userPromise
            .then((user) => deferredAuthData.resolve(user))
            .catch(() => deferredAuthData.resolve(null));

        return deferredAuthData.promise;
    };
}



// WEBPACK FOOTER //
// ./auth/auth-data.js